import React, { Component } from 'react';
import $ from 'jquery';
import AppStore from '../../stores/AppStore';
import _get from 'lodash/get';
import { getPaymentCardNetwork } from '../../utility/card-utils';
import { localsMessages } from '../../utility/getTemplateData';
import { StyleSheet, css } from 'aphrodite';
import _isEmpty from 'lodash/isEmpty';

let threeDSText = localsMessages('common/threeDSecure');

const LOADING_GIF_SOURCE = 'https://www.paypalobjects.com/ui-web/money-icons/partnerships/mbLoader_256_sm.gif';

const STYLES = StyleSheet.create({
	spinnerAlign: {
		margin: '30px auto 30px'
	},
	cardImg: {
		marginTop: '24px'
	}
});

class ThreeDSSpinner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cardImg: null,
			network: null
		}
	}

	setNetworkDetails = () => {
		const fundingOptions = AppStore.getFundingOptions();
		let cardImg = _get(fundingOptions, 'sources[0].payment_card.issuer.thumbnail_logo_url');
		let network = getPaymentCardNetwork(_get(fundingOptions, 'sources[0].payment_card'));
		let myData = AppStore.getAllData() || {};
		if (cardImg === null || _isEmpty(cardImg) || typeof cardImg === 'undefined') {
			const cardType = myData.cardSpec.cardSpec.type .replace(/[.,_]|\s\(.*\)/g, '')
			.replace(/[\s_]/g, '-')
			.toLowerCase();
			cardImg = `https://www.paypalobjects.com/digitalassets/c/consumer/p2p/funding-sources/${cardType}.png`;
		}
		if (network === null || _isEmpty(network) || typeof network === 'undefined') {
			network = myData.cardSpec.cardSpec.type.replace(/[_]/g, ' ');
		}
		this.setState({ cardImg, network });
	}

	componentDidMount() {
		// Hide the donate spinner in the background
		// to prevent double spinners
		$('.spinneroverlay').hide();
		this.setNetworkDetails();
		
	}

	render() {
		let confirmingWithText = _get(threeDSText, 'confirmingWith', 'We\'re confirming your info with {network}');
		const confirmingWith = confirmingWithText.replace(new RegExp('{network}', 'g'), this.state.network);

		return (
			<div className="three-ds-spinner donatespinner">
				<div className="loadingcontent">
					<div className="text-center">
						{/* <div className={`spinner ${css(STYLES.spinnerAlign)}`}></div> */}
						<div id="threeDSSpinnerImg">
							<img src={LOADING_GIF_SOURCE} height="150"/>
						</div>
						<p id="waitText">{confirmingWith}</p>
						<div className={`${css(STYLES.cardImg)}`} >
							{this.state.cardImg ? <img src={this.state.cardImg} alt="Card logo" /> : ''}
						</div>
						<p id="spinnerText"></p>
					</div>
				</div>
			</div>
		);
	}
}

export default ThreeDSSpinner;



// WEBPACK FOOTER //
// ./components/threeDS/ThreeDSSpinner.js